export default __webpack_public_path__ + "db33e70bc9dee9fa9ae9737ad83d77ba.ttf";